<script>
import CommonTableComponent from "@/components/table.vue";
import pagination from "@/mixins/pagination";
import tableSearch from "@/mixins/tableSearch";
import apiEndpoints from "@/services/apiEndpoints";
import Input from "@/mixins/inquiries/input";
import ModalInquiryDetail from "@/views/pages/inquiries/modals/ModalInquiryDetail.vue";
import {dateWithWeekDay} from "@/filters";

export default {
  name: "notificationInquiries",
  mixins: [pagination, tableSearch,Input],
  components: {
    CommonTableComponent,
    ModalInquiryDetail,
  },
  data() {
    return {
      filters: {
        page: 1,
        column: this.$route.query.column || "created_at",
        dir: this.$route.query.dir || "DESC",
        is_top_notification: 1
      },
      busyGetData: false,
      inquiries: [],
      isExpanded: false,
    };
  },
  created() {
    this.getData()
  },
  methods: {
    async getData() {
      this.busyGetData = true;
      const response = await this.$http.get(apiEndpoints.top_notification_inquiries, {
        ...this.filters,
      });
      const {status, data} = response;
      this.busyGetData = false;
      if (status) {
        const result = data.result;
        const inquiries = this.$_.isEmpty(result.data) ? [] : result.data;
        this.inquiries = this.transferData(inquiries);
        const meta = this.$_.isEmpty(result.meta) ? [] : result.meta;
        this.setMeta(meta);
      }
    },
    updateUrlFilters() {
      this.getData()
    },
    toggleItem() {
      this.isExpanded = !this.isExpanded;
    },
    transferData(data) {
      return data.map(item => {
        const formattedCreatedDate = dateWithWeekDay(item.created_at, 'YYYY/MM/DD');
        const formattedLatestCreatedDate = dateWithWeekDay(item.latest_discharger_created_at, 'YYYY/MM/DD');
        const formattedSubmitAtDate = item.latest_submit_at ? dateWithWeekDay(item.latest_submit_at, 'YYYY/MM/DD') : "";

        return {...item, created_at: formattedCreatedDate, submit_at: formattedSubmitAtDate, latest_discharger_created_at: formattedLatestCreatedDate};
      });
    },
  },
  watch: {
    'filters.page': {
      immediate: false,
      handler() {
        this.getData();
      },
    },
  },
  computed: {
    headers() {
      return [
        {
          text: "最終お問合せ日",
          value: "created_at",
          sortable: true,
          width: 10
        },
        {
          text: "種別",
          value: "inquiry_type",
          sortable: true,
          width: 10
        },
        {
          text: "事業者",
          value: "discharger_name_abbreviated",
          sortable: true,
          width: 10
        },
        {
          text: "タイトル",
          value: "title",
          sortable: true,
          width: 70
        },
      ];
    },
  },
};
</script>

<template>
  <div>
      <ModalInquiryDetail
      ref="inquiryDetail"
      @onAnswered="onAnswered"
    />
  
  <div class="row">
    <b-overlay
      :show="busyGetData"
      rounded
      opacity="0.6"
      spinner-small
      spinner-variant="primary"
      class="d-inline-block"
    >
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div
              @click="toggleItem()"
              v-b-toggle.collapse-notification-inquiries
              class="card-title mb-2 mt-2"
            >
              <span class="font-size-16">お問合せ（{{ meta.total }}件）</span>
              <span :class="{'rotate': isExpanded}" class="icon">▼</span>
            </div>
            <b-collapse id="collapse-notification-inquiries">
              <CommonTableComponent :scrollAble="inquiries.length >= this.$constant.scroll_able_records">
                <thead class="table-light">
                <tr>
                  <th
                    :style="`width: ${item.width}`"
                    v-for="(item, index) in headers"
                    :key="index"
                    :class="getHeaderClass(item)"
                  >
                    <span v-if="item.sortable" @click="clickSort(item.value)">
                      {{ item.text }}
                      <i :class="getSortClass(item.value)"></i>
                    </span>
                    <span v-else>
                      {{ item.text }}
                    </span>
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, index) in inquiries" :key="index" @click="openinQuiryDetailModal(item)">
                  <td>
                    {{ item.latest_discharger_created_at }}
                  </td>
                  <td>
                    {{ item.inquiry_type }}
                  </td>
                  <td>
                    {{ item.discharger_name_abbreviated }}
                  </td>
                  <td>
                    {{ item.title }}
                  </td>
                </tr>
                <tr v-if="!inquiries.length && !busyGetData">
                  <td colspan="7" class="text-center">
                    お問合せはありません
                  </td>
                </tr>
                </tbody>
              </CommonTableComponent>
            </b-collapse>
          </div>
        </div>
      </div>
    </b-overlay>
  </div>
  <!-- end row -->
</div>
</template>
<style scoped>
.icon {
  float: right;
  transition: transform 0.3s;
}

.rotate {
  transform: rotate(-90deg);
}
</style>
